
    <div class="hi-lo-window">
      <div class="reply-loader" *ngIf="_loading || !luckyCards.length">
        <i class="fal fa-spinner fa-spin" [hidden]="_error"></i>
        <i class="fal fa-exclamation-triangle" [hidden]="!_error"></i>
      </div>
      <div class="blackjack-game-content" *ngIf="!_loading && luckyCards.length > 0">
        <div class="blackjack-card-canvas">
          <div class="deck-cards">
            <div class="blackjack-card-container">
              <div class="blackjack-card card-container" *ngFor="let card of luckyCards; let index = index">
                <div class="card__styled_card" [ngStyle]="{ left: index * 2.75 + 'em' }">
                  <div
                    class="game-card card__front"
                    style="transform: rotateY(0deg)"
                    [ngClass]="'__card_' + getCardName(card)"
                  ></div>
                  <div class="game-card card__back" style="transform: rotateY(180deg)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-hi-lo/reply-hi-lo.component.ts.ReplyHiLoComponent.html